<template>
  <div class="automaticControl">
    <el-row>
      <el-button
        size="small"
        type="primary"
        plain
        icon="el-icon-plus"
        @click="addList"
        >新增</el-button
      >
      <el-button type="primary" size="small" @click="submitForm"
        >提交</el-button
      >
    </el-row>
    <ul>
      <li v-for="(v, i) in list" :key="i">
        <div class="row">
          <span>状态</span>
          <el-radio-group v-model="v.setchanger">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </div>
        <div class="row">
          <span>温度</span>
          <el-input-number
            v-model="v.settemperature"
            :precision="1"
            size="small"
          ></el-input-number>
          ℃
        </div>
        <div class="row">
          <span>频率</span>
          <el-input-number
            :min="0"
            v-model="v.setfrequency"
            :precision="0"
            size="small"
          ></el-input-number>
          %
        </div>
        <span class="closeBtn el-icon-close" @click="detaile(v)"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      list: [{ setchanger: 1, settemperature: 0, setfrequency: 0 }],
    };
  },
  methods: {
    async getData() {
      let res = await api.DMGetAutomaticControl(
        {},
        this.activeItem?.id?.id || this.activeItem?.deviceId
      );
      if (res?.status == 200) {
        let obj = res.data.find((v) => {
          return v.key === "control_cparam";
        });
        if (obj && obj.value && JSON.parse(obj.value).length) {
          this.list = JSON.parse(obj.value);
        }
      }
    },

    addList() {
      if (this.list.length == 4) {
        this.$message.warning("已达到最大数量");
        return;
      }
      this.list.push({ setchanger: 1, settemperature: 0, setfrequency: 0 });
    },
    detaile(item) {
      let index = this.list.indexOf(item);
      if (index !== -1) {
        this.list.splice(index, 1);
      }
    },

    async submitForm() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.DMSetAutomaticControl(
        {
          control_cparam: JSON.stringify(this.list),
        },
        this.activeItem?.id?.id || this.activeItem?.deviceId
      );
      if (res?.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.$message.success("操作成功!");
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.automaticControl {
  width: 96%;
  height: 98%;
  margin: 0 auto;
  // @include setFlexCenter;
  ul {
    width: 100%;
    height: calc(100% - 60px);
    margin-top: 18px;
    li {
      display: inline-block;
      width: calc(50% - 25px);
      height: 196px;
      background: #ffffff;
      margin: 0 25px 20px 0;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.01),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08),
        0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      border-radius: 8px;
      position: relative;
      .closeBtn {
        position: absolute;
        top: 13px;
        right: 16px;
        font-size: 18px;
        color: #c0c0c0;
        cursor: pointer;
        &:hover {
          color: #63c9ca;
        }
      }
      .row {
        width: 90%;
        margin: 20px 0 20px 20px;
        span {
          margin-right: 20px;
        }
      }
      .row:nth-child(1) {
        margin-top: 34px;
      }
    }
  }
}
</style>
